import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=8a4be8ce&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=8a4be8ce&prod&lang=css&"
import style1 from "./BaseInfo.vue?vue&type=style&index=1&id=8a4be8ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4be8ce",
  null
  
)

export default component.exports